export default "__VITE_ASSET__BmFXkIuZ__"